import React from "react";
import { Check } from "@phosphor-icons/react";
import { SideTab } from "../../../../components/SideTab";
import { Button } from "../../../../components/common/Button";
import { Input } from "../../../../components/common/Input";
import {
  ButtonContainer,
  CheckboxAppearence,
  CheckboxContainer,
  CheckboxInput,
  Row,
  StatusBox,
  Table,
  TableCell,
  TableCellEmpty,
  TableHeader,
  Title,
} from "../../styles";

interface ISecurityInfo {
  id: string;
  Userinfo: {
    id: string;
    name: string;
    email: string;
    phone: string;
    Vehicle: {
      id: string;
      vehicle: string;
      color: string;
      plate: string;
      type: string;
    }[];
  };
  Employee: {
    id: string;
    status: string;
  };
  AlwaysAlert: string;
  UserDistance: {
    distance: {
      text: string;
    };
    duration: {
      text: string;
    };
  };
  OccurrenceDistance: {
    distance: {
      text: string;
    };
  };
  online: string;
  status: string;
}

interface SecuritySelectionSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  securitiesList: ISecurityInfo[] | null;
  selectedSecurityId: string;
  selectedSecurity: ISecurityInfo | undefined;
  onCheckboxChange: (id: string) => void;
  onTriggerSecurity: () => void;
  occurrence: any;
}

export function SecuritySelectionSidebar({
  isOpen,
  onClose,
  securitiesList,
  selectedSecurityId,
  selectedSecurity,
  onCheckboxChange,
  onTriggerSecurity,
  occurrence,
}: SecuritySelectionSidebarProps) {
  return (
    <SideTab
      open={isOpen}
      width="40%"
      title={"Acionar um segurança"}
      toggleFunction={onClose}
    >
      <Title>Selecionar um segurança para a ação:</Title>
      <Table>
        <thead>
          <tr>
            <TableHeader></TableHeader>
            <TableHeader>Nome de usuário</TableHeader>
            <TableHeader>Distância da ocor.</TableHeader>
            <TableHeader>Sempre alerta</TableHeader>
            <TableHeader>Status</TableHeader>
          </tr>
        </thead>
        <tbody>
          {!securitiesList ? (
            <tr>
              <TableCellEmpty colSpan={8}>
                Nenhum dado encontrado
              </TableCellEmpty>
            </tr>
          ) : (
            securitiesList?.map((val) => {
              return (
                <tr key={val.id}>
                  <TableCell>
                    <CheckboxContainer onClick={() => onCheckboxChange(val.id)}>
                      <CheckboxInput
                        checked={selectedSecurityId === val.id}
                        onChange={() => onCheckboxChange(val.id)}
                        data-id={val.id}
                      />
                      <CheckboxAppearence
                        isChecked={selectedSecurityId === val.id}
                      >
                        <Check size={36} />
                      </CheckboxAppearence>
                    </CheckboxContainer>
                  </TableCell>
                  <TableCell>{val.Userinfo?.name || "-"}</TableCell>
                  <TableCell>
                    {val.OccurrenceDistance?.distance?.text || "-"}
                  </TableCell>
                  <TableCell>{val.AlwaysAlert || "-"}</TableCell>
                  <TableCell>
                    {val.online === "Online" ? (
                      <StatusBox status={val.status}>Online</StatusBox>
                    ) : (
                      <StatusBox status={val.status}>Offline</StatusBox>
                    )}
                  </TableCell>
                </tr>
              );
            })
          )}
        </tbody>
      </Table>
      {selectedSecurityId.length > 0 && selectedSecurity ? (
        <>
          <Title>Informações do segurança</Title>
          <Row>
            <Input.Root flex="2">
              <Input.Label title="Nome:" htmlFor="securityInfoName" />
              <Input.Wrapper>
                <Input.Content
                  id="securityInfoName"
                  type="text"
                  value={selectedSecurity.Userinfo?.name || "-"}
                  readOnly
                />
              </Input.Wrapper>
            </Input.Root>
            <Input.Root flex="1">
              <Input.Label
                title="Sempre alerta"
                htmlFor="securityInfoAlwaysAlert"
              />
              <Input.Wrapper>
                <Input.Content
                  id="securityInfoAlwaysAlert"
                  type="text"
                  value={selectedSecurity.AlwaysAlert || "-"}
                  readOnly
                />
              </Input.Wrapper>
            </Input.Root>
          </Row>
          <Row>
            <Input.Root flex="1">
              <Input.Label
                title="Tipo de veículo"
                htmlFor="securityInfoVehicleType"
              />
              <Input.Wrapper>
                <Input.Content
                  id="securityInfoVehicleType"
                  type="text"
                  value={selectedSecurity.Userinfo?.Vehicle?.[0]?.type || "-"}
                  readOnly
                  disabled
                />
              </Input.Wrapper>
            </Input.Root>
            <Input.Root flex="2">
              <Input.Label
                title="Veículo"
                htmlFor="securityInfoVehicle"
              />
              <Input.Wrapper>
                <Input.Content
                  id="securityInfoVehicle"
                  type="text"
                  value={selectedSecurity.Userinfo?.Vehicle?.[0]?.vehicle || "-"}
                  readOnly
                  disabled
                />
              </Input.Wrapper>
            </Input.Root>
            <Input.Root flex="1">
              <Input.Label title="Placa" htmlFor="securityInfoPlate" />
              <Input.Wrapper>
                <Input.Content
                  id="securityInfoPlate"
                  type="text"
                  value={selectedSecurity.Userinfo?.Vehicle?.[0]?.plate || "-"}
                  readOnly
                  disabled
                />
              </Input.Wrapper>
            </Input.Root>
          </Row>
          <Row>
            <Input.Root flex="1">
              <Input.Label
                title="Distância até o usuário"
                htmlFor="securityInfoDistance"
              />
              <Input.Wrapper>
                <Input.Content
                  id="securityInfoDistance"
                  type="text"
                  value={selectedSecurity.UserDistance?.distance?.text || "-"}
                  readOnly
                  disabled
                />
              </Input.Wrapper>
            </Input.Root>
            <Input.Root flex="1">
              <Input.Label
                title="Tempo previsto de chegada"
                htmlFor="securityInfoTimeToArrive"
              />
              <Input.Wrapper>
                <Input.Content
                  id="securityInfoTimeToArrive"
                  type="text"
                  value={selectedSecurity.UserDistance?.duration?.text || "-"}
                  readOnly
                  disabled
                />
              </Input.Wrapper>
            </Input.Root>
          </Row>
          <ButtonContainer>
            <Button.Root
              type="button"
              backgroundColor="#0079B1"
              onClick={onTriggerSecurity}
            >
              <Button.Content
                title="Acionar este segurança"
                fontSize="12px"
              />
            </Button.Root>
          </ButtonContainer>
        </>
      ) : null}
    </SideTab>
  );
}
